/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LoginBind.vue?vue&type=template&id=585619d7&scoped=true&"
import script from "./LoginBind.vue?vue&type=script&lang=js&"
export * from "./LoginBind.vue?vue&type=script&lang=js&"
import style0 from "./LoginBind.vue?vue&type=style&index=0&id=585619d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585619d7",
  null
  
)

export default component.exports